export default "__VITE_ASSET__BXnKvnxp__"